<template lang="pug">
management-page.scrollable(title="Feedback"
                @fetchData="pullFeedback"
                :creatable="false"
                :searchable="false"
                :showHeader="false"
                :pagination="pagination"
                :resetOffsetToDefaultOnMount="!extendStateData"
                :searchPageSize="searchPageSize"
                ref="managementPage")
  template(v-slot:body="{ totalResults, visibleResults }")
    .feedback
      .chart-configuration
        .chart-toolbar
          aiq-row(:gutter="16")
            .dropdown-filters
              .dropdown-filter
                segment-select(:customer-segment-filter-options="customerSegmentNameFilterOptions"
                      :segment-alias="segmentAlias"
                      is-select-multiple
                      is-select-collapse-tags
                      @change="onCustomerSegmentNameFilterChange"
                      @on-segment-hover="onSegmentHover"
                      :isCollapsible="true")
        .breakdown
        .time-range-filter
          aiq-date-picker(v-model="dateRange"
                          @change="handleDatePickerChange($event)"
                          type="daterange"
                          placeholder="Select date range",
                          popper-class="metrics-time-range__date-picker-popup"
                          :shortcuts="datePickerOptions.shortcuts"
                          :disabled-date="datePickerOptions.disabledDate"
                          :teleported="false"
                          format="YYYY/MM/DD"
                          :clearable="false")
      .chart-grid
        aiq-row(v-if="initialLoaded && surveyType === 'csat'" :gutter="16")
          aiq-col(:span="24")
            overview-chart(v-if="configs.postchat_survey"
                        :dateRange="dateRangeUtc"
                         :BucketOptions="BucketOptions"
                        :filters="selectedFilters"
                        :chartConfig="csatOverviewChartConfig"
                        :formatXTick="xAxisFormatForSurveyCharts"
                        :formatYTick="intCountFormatter"
                        shouldShowTotalOnTooltip=false
                        yLabel="Number of Feedback Requests"
                        grouped
                        :useDebounceForLoadMetrics="true"
                        :shouldHandlePartialDates="true"
                        :reportFileName="returnReportFileName('CSAT')"
                        :getOriginalData="originalSurveyChartData"
                        @onXLabelsChange="xLabelsSurveyChart=$event"
                        @onChartDataChange="onChartDataChange($event)"
                        :formatY2Tick="percentFormatter"
                        y2Label="CSAT Score"
                        :y2ScaleMin=0
                        :y2ScaleMax=100
                        :barWidthRatio="0.2"
                        )

        aiq-row(v-if="initialLoaded && surveyType === 'nps'" :gutter="16")
          aiq-col(:span="24")
            overview-chart(v-if="configs.postchat_survey"
                          :dateRange="dateRangeUtc"
                          :BucketOptions="BucketOptions"
                          :filters="selectedFilters"
                          :chartConfig="npsOverviewChartConfig"
                          :formatXTick="xAxisFormatForSurveyCharts"
                          :formatYTick="percentFormatter"
                          :yLabel="$t('metrics_tab.customer_tab.feedback_tab.nps.y_label')"
                          :yScaleMin=0
                          :yScaleMax=100
                          :y2Label="$t('metrics_tab.customer_tab.feedback_tab.nps.nps_score')"
                          :y2ScaleMin=-100
                          :y2ScaleMax=100
                          grouped
                          :useDebounceForLoadMetrics="true"
                          :shouldHandlePartialDates="true"
                          :reportFileName="returnReportFileName('NPS')"
                          :getOriginalData="originalSurveyChartData"
                          @onXLabelsChange="xLabelsSurveyChart=$event"
                          @onChartDataChange="onChartDataChange($event)"
                          :barWidthRatio="0.2"
                          )
      .feedback-table
        .feedback-table-toolbar
          .flex-spacer
          FilteredInput.search(v-model="searchTerm" size="small" placeholder="Search Lynq ID, Conversation ID, and Last Feedback")
          aiq-select(@change="applyScoreFilter"
                     v-model="scoreObjects"
                     filterable
                     clearable
                     :suffix-icon="Icon.CaretBottom"
                     size="small"
                     placeholder="Score"
                     multiple
                     :reserve-keyword="false")
            aiq-option(v-for="option in scoreFilterOptions"
                       :key="option.value"
                       :label="option.name"
                       :value="option")
          aiq-select(v-model="stateFilter"
                     size="small"
                     clearable
                     placeholder="Status")
            aiq-option(v-for="state in surveryStates"
                        :key="state"
                        :label="state"
                        :value="state")
          .pagination-info
            span Matched Results: #[b {{ totalResults }}]
            span  &nbsp;Showing Results: #[b 0 - {{ visibleResults }}]
          aiq-button.export(@click="exportTable")
            i.iq-ico-export


    aiq-table.feedback-scrollbar(:data="feedbackItems"
                    ref="customersTable"
                    style="width: 100%"
                    :default-sort="sortOrder"
                    v-loading="loading")
      aiq-table-column(label="Lynq ID", :min-width="7", :sortable="true", :sort-method="onSortID('customer_id')" label-class-name="is-bordered normal-word-break")
        template(v-slot:default="scope")
          router-link(:to="{ name: 'ConversationByCustomerId', params: { id: getLynqId(scope.row) } }")
            span {{ getLynqId(scope.row) }} &nbsp;
      aiq-table-column(label="Conversation ID", :min-width="7", :sortable="true", :sort-method="onSortID('conversation_id')" label-class-name="is-bordered normal-word-break")
        template(v-slot:default="scope")
          router-link(:to="{ name: 'ConversationByCustomerId', query: { conversation_id: getConversationId(scope.row) } }")
            span {{ getConversationId(scope.row) }} &nbsp;
      aiq-table-column(label="Last Feedback Status", :min-width="6", :sortable="true", :sort-method="onSortStatus", label-class-name="is-bordered normal-word-break")
        template(v-slot:default="scope")
          span {{ getFeedbackStatus(scope.row) }} &nbsp;
      aiq-table-column(prop="updated_at", :min-width="10", label="Last Feedback Status Date", :sortable="true", :sort-method="onSortUpdatedAtTime", label-class-name="is-bordered normal-word-break")
        template(v-slot:default="scope")
          span {{ getLastFeedbackStatusDate(scope.row) }} &nbsp;
      aiq-table-column(label="Last Feedback",:min-width="11",  :sortable="false", label-class-name="is-bordered normal-word-break")
        template(v-slot:default="scope")
          span {{ getFormattedComments(scope.row) }} &nbsp;
      aiq-table-column(label="Last Feedback Score", :min-width="5", :sortable="true", :sort-method="onSortScore", label-class-name="is-bordered normal-word-break")
        template(v-slot:default="scope")
          span {{ getFormattedCSATscore(scope.row) }} &nbsp;


</template>


<style lang="scss">
@import "../../../../styles/aiq-variables.scss";
</style>

<script>
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import debounce from 'lodash/debounce';
import _ from 'lodash';
import dayjs from '@/localPlugins/dayjs';

import ManagementPage from '@/components/ManagementPage/ManagementPage.vue';
import FilteredInput from '@/components/FilteredInput.vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import LayoutMain from '@/components/layouts/main.vue';
import OverviewChart from '@/components/Chart.vue';
import SegmentSelect from '@/components/SegmentsSelect/SegmentsSelect.vue';
import { downloadAsFile, useTimeZone, getMetricsTimeZoneAbbr, formatDateWithTimezone } from '@/libs';
import { upperFirstStrings } from '@/libs/profile';
import { PAGINATION_DEFAULT } from '@/constants/pagination';
import {
  setToEndOfDay,
  datePickerDefaultOptions,
  getNonReactiveDateRange,
  dstDateRangeUtc,
  lastAvailableMonthAndQuarterRange,
  createPickerDateRangeOption,
  defaultDateRange,
  DAY_RANGE,
} from '../../configs/dateRange';
import { loadFilterOptions } from '../../helpers/filterHelper';
import PlatformFiltersMixin from '../../Platform/children/selectableFilters/SelectableFilters';
import { cloneDeep } from 'lodash';

const SEARCH_PAGE_SIZE = 100;
const DEBOUNCE_DELAY_MS = 250;

const COLORS = {
  red: '#FF6384',
  orange: '#FFBE50',
  yellow: '#FFEC71',
  grey: '#D7D9DE',
  blue: '#4671B3',
  green: '#4BC0C0',
};

const BucketOptions = [
  {
    value: 'day',
    label: 'Daily',
    isDefault: true,
    xAxisFormat: value => dayjs(value).format('MMM DD'),
  },
  {
    value: 'week',
    label: 'Weekly',
    xAxisFormat: value => {
      const start = dayjs(value);
      const end = dayjs(value).add(DAY_RANGE, 'days');
      const format = 'MMM DD';
      return `${start.format(format)} - ${end.format(format)}`;
    },
  },
  {
    value: 'month',
    label: 'Monthly',
    xAxisFormat: value => dayjs(value).format('MMM'),
  },
];

const csatOverviewChartConfig = {
  name: 'postchat_survey',
  title: 'CSAT',
  metric: 'csat_score',
  lines: {
    very_unsatisfied: {
      label: 'metrics_tab.customer_tab.summary_tab.feedback.very_unsatisfied',
      position: 1,
      color: COLORS.red,
    },
    unsatisfied: {
      label: 'metrics_tab.customer_tab.summary_tab.feedback.unsatisfied',
      position: 2,
      color: COLORS.orange,
    },
    neutral: {
      label: 'metrics_tab.customer_tab.summary_tab.feedback.neutral',
      position: 3,
      color: COLORS.yellow,
    },
    satisfied: {
      label: 'metrics_tab.customer_tab.summary_tab.feedback.satisfied',
      position: 4,
      color: COLORS.grey,
    },
    very_satisfied: {
      label: 'metrics_tab.customer_tab.summary_tab.feedback.very_satisfied',
      position: 5,
      color: COLORS.green,
    },
    csat_score: {
      label: 'metrics_tab.customer_tab.summary_tab.feedback.csat_score',
      position: 6,
      axis: 'y2',
      type: 'spline',
    },
  },
  graphParams: {
    metricCategoryForY: 'feedback',
  },
  helpText: 'metrics_tab.customer_tab.summary_tab.feedback.help',
  maxTickLabelCount: 8,
  leftPadding: null,
  rightPadding: null,
};

const npsOverviewChartConfig = {
  name: 'postchat_survey',
  title: 'NPS',
  metric: 'nps_score',
  lines: {
    detractors: {
      label: 'metrics_tab.customer_tab.summary_tab.feedback.detractors',
      position: 1,
      color: COLORS.red,
    },
    passives: {
      label: 'metrics_tab.customer_tab.summary_tab.feedback.passives',
      position: 2,
      color: COLORS.yellow,
    },
    promoters: {
      label: 'metrics_tab.customer_tab.summary_tab.feedback.promoters',
      position: 3,
      color: COLORS.green,
    },
    promoter_score: {
      label: 'metrics_tab.customer_tab.summary_tab.feedback.promoter_score',
      position: 4,
      axis: 'y2',
      y2Category: 'feedback',
      type: 'spline',
    },
    nps_score: {
      label: 'metrics_tab.customer_tab.feedback_tab.nps.nps_score',
      position: 5,
      axis: 'y2',
      y2Category: 'nps_score',
      type: 'line',
    },
  },
  graphParams: {
    metricCategoryForY: 'percent',
  },
  helpText: 'metrics_tab.customer_tab.summary_tab.feedback.help',
  maxTickLabelCount: 8,
  leftPadding: null,
  rightPadding: null,
};

export default {
  name: 'Feedback',
  components: {
    ManagementPage,
    LayoutMain,
    OverviewChart,
    FilteredInput,
    SegmentSelect,
  },
  props: {
    query: {
      type: String,
      default: '',
    },
    filterTypeProp: String,
    filterByAgentProp: Object,
  },
  mixins: [PlatformFiltersMixin],
  data() {
    return {
      csatOverviewChartConfig,
      npsOverviewChartConfig,
      selectedFilters: [],
      selectedFiltersWithSegmentIds: [],
      intCountFormatter: v => (Math.floor(parseFloat(v)) === parseFloat(v) ? v : null),
      durationFormatter: this.$aiq.formatters.timeDelta,
      dateRange: defaultDateRange(),
      BucketOptions: BucketOptions,
      pagination: PAGINATION_DEFAULT,
      filterType: this.filterTypeProp,
      filterByAgent: this.filterByAgentProp,
      sortOrder: { prop: this.datePickerOption || 'last_chat_time', order: 'ascending' },
      searchTerm: '',
      filterScores: null,
      initialLoaded: false,
      percentFormatter: v => `${v}%`,
      loading: true,
      segmentAlias: '',
      extendStateData: false,
      searchPageSize: SEARCH_PAGE_SIZE,
      scoreObjects: [],
      agentsEndpoint: 'metrics_by_agent',
      surveyChartData: [],
      originalSurveyChartData: {},
      xLabelsSurveyChart: {},
      surveryStates: ['Requested', 'Received'],
      stateFilter: '',
      tzAbbr: '',
      timezone: '',
    };
  },
  computed: {
    ...mapState({
      feedbackItems: state => state.metrics.survey.feedbackItems,
      surveyType: state => state.metrics.survey.surveyType,
      scrollToConversation: state => state.featureFlags.FEATURE_FLAGS.SCROLL_TO_CONVERSATION,
    }),
    ...mapGetters({
      configs: 'configs/graphsConfigs',
    }),
    dateRangeUtc() {
      return dstDateRangeUtc(this.dateRange);
    },
    datePickerOptions() {
      return {
        ...datePickerDefaultOptions(),
        shortcuts: lastAvailableMonthAndQuarterRange.map(createPickerDateRangeOption),
      };
    },
    scoreFilterOptions() {
      let scoreRange = [];
      if (this.surveyType === 'csat') {
        // Range 1 ~ 5
        scoreRange = [...Array(5).keys()].map(i => i + 1);   // eslint-disable-line
      } else if (this.surveyType === 'nps') {
        // Range 0 ~ 10
        scoreRange = [...Array(11).keys()]; // eslint-disable-line
      }
      return scoreRange.map(index => ({ value: index, name: String(index) }));
    },
  },
  watch: {
    dateRange: debounce(function onDateRangeChange(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.loadList({ searchOffset: 0 });
      }
    }, 1),

    filterScores() {
      this.$refs.managementPage.resetAndFetchData();
    },

    selectedFilters:
      function onfilterChange(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$refs.managementPage.resetAndFetchData();
        }
      },

    searchTerm() {
      this.$refs.managementPage.resetAndFetchData();
    },

    stateFilter(newState) {
      if (!newState) {
        this.searchTerm = '';
        return;
      }
      this.searchTerm = newState === 'Requested' ? 'sent' : 'submitted';
    },
  },
  methods: {
    ...mapActions({
      getFeedbackList: 'metrics/getFeedbackList',
      getFeedbackType: 'metrics/getFeedbackType',
    }),
    setBreakdown(value) {
      this.selectedBreakdownOption = this.filteredBreakdownOptions.find(
        option => option.value === value,
      );
    },

    getLynqId(feedback) {
      return get(feedback, 'customer_id', '');
    },

    getConversationId(feedback) {
      return get(feedback, 'conversation_id', '');
    },

    getFeedbackStatus(feedback) {
      const status = get(feedback, 'state', '');
      return status === 'submitted' ? 'Received' : 'Requested';
    },

    getLastFeedbackStatusDate(feedback) {
      const updated_at = get(feedback, 'updated_at', '');
      return `${formatDateWithTimezone(updated_at, this.timezone, 'MMM DD, YYYY hh:mm A')} ${this.tzAbbr}`;
    },

    getFormattedJoinedDate(feedback) {
      return dayjs(feedback.join_date).format('YYYY-MM-DD');
    },
    getFormattedComments(feedback) {
      const comments = get(feedback, 'content.comments', '');
      if (!comments) {
        return '';
      }
      return comments;
    },
    getFormattedCSATscore(feedback) {
      const csatScore = get(feedback, 'value', '');
      if (csatScore === '') {
        return '';
      }
      return csatScore;
    },
    getColMinWidth() {
      return '95';
    },
    getFormattedFeedbackTime(feedback) {
      const feedbackTime = get(feedback, 'time_stamp', '');
      if (!feedbackTime) {
        return feedbackTime;
      }
      return `${formatDateWithTimezone(feedbackTime, this.timezone, 'MMM DD, YYYY hh:mm A')} ${this.tzAbbr}`;
    },
    getFormattedCSATDescription(feedback) {
      const csatDescription = get(feedback, 'content.description', '');
      if (!csatDescription) {
        return '';
      }
      return csatDescription;
    },
    goToLastConversation(feedback) {
      const lastConversationCustomerId = get(feedback, 'customer_id');
      if (!lastConversationCustomerId) {
        return;
      }
      this.$router.push({
        name: 'ConversationByCustomerId',
        params: { id: lastConversationCustomerId },
      });
    },

    goToFeedbackConversation(feedback) {
      // Currently there is no way to get conversation id of this feedback.
      // Therefore we are redirecting to recent conversation.
      this.goToLastConversation(feedback);
    },

    getPrimaryAgentName(feedback) {
      return upperFirstStrings(
        get(feedback, 'primary_agent_profile.first_name', ''),
        get(feedback, 'primary_agent_profile.last_name', ''),
      );
    },

    getSenderAgentName(feedback) {
      return upperFirstStrings(
        get(feedback, 'sender_agent_profile.first_name', ''),
        get(feedback, 'sender_agent_profile.last_name', ''),
      );
    },

    getCustomerName(feedback) {
      const name = upperFirstStrings(
        get(feedback, 'customer_profile.first_name', ''),
        get(feedback, 'customer_profile.last_name', ''),
      );
      const customerDefaultName = [this.$t('metrics_tab.plaform_tab.summary_tab.feedback.customer'), get(feedback, 'customer_id')].join(' ');
      return name !== '' ? name : customerDefaultName;
    },

    filterToPrimaryAgent(feedback) {
      const primaryAgentName = this.getPrimaryAgentName(feedback);
      if (primaryAgentName) {
        this.$router.push({
          name: 'Users',
          query: {
            query: primaryAgentName,
          },
        });
      }
    },

    onSortCustomerName(a, b) {
      return this.getCustomerName(a) <= this.getCustomerName(b) ? 1 : -1;
    },

    onSortJoinedDate(a, b) {
      return a.join_date <= b.join_date ? 1 : -1;
    },

    onSortScore(a, b) {
      const score1 = get(a, 'value', 0);
      const score2 = get(b, 'value', 0);
      if (score1 === score2) {
        return 0;
      }
      return score1 < score2 ? 1 : -1;
    },
    onSortFeedbackTime(a, b) {
      const leftFeedbackTime = get(a, ['time_stamp']);
      const rightFeedbackTime = get(b, ['time_stamp']);

      return leftFeedbackTime < rightFeedbackTime ? 1 : -1;
    },

    onSortStatus(a, b) {
      return get(a, 'state', '').toLowerCase() <= get(b, 'state', '').toLowerCase() ? 1 : -1;

    },

    onSortUpdatedAtTime(a, b) {
      const leftFeedbackTime = get(a, ['updated_at']);
      const rightFeedbackTime = get(b, ['updated_at']);

      return leftFeedbackTime < rightFeedbackTime ? 1 : -1;
    },

    onSortID(path) {
      return (a, b) => {
        return a[path] < b[path] ? 1 : -1;
      };
    },

    onSortLastChatTime(a, b) {
      const sortOrder = this.$refs.customersTable.store.states.sortOrder;

      const leftLastChatTime = get(a, 'last_chat_details.last_chat_time');
      const rightLastChatTime = get(b, 'last_chat_details.last_chat_time');

      // Always keep undefined at the bottom
      if (!leftLastChatTime) {
        return sortOrder === 'ascending' ? 1 : -1;
      }

      if (!rightLastChatTime) {
        return sortOrder === 'ascending' ? -1 : 1;
      }

      return leftLastChatTime <= rightLastChatTime ? 1 : -1;
    },

    onSortPrimaryAgent(a, b) {
      return this.getPrimaryAgentName(a) <= this.getPrimaryAgentName(b) ? 1 : -1;
    },

    onSortSenderAgent(a, b) {
      return this.getSenderAgentName(a) <= this.getSenderAgentName(b) ? 1 : -1;
    },

    onSortCustomerSegment(a, b) {
      return a.customer_segment <= b.customer_segment ? 1 : -1;
    },

    exportTable() {
      const data_points = [];
      for (const c of this.feedbackItems) {
        data_points.push(
          {
            'Lynq ID': this.getLynqId(c) || '',
            'Conversation ID': this.getConversationId(c) || '',
            'Last Feedback Status': this.getFeedbackStatus(c) || '',
            'Last Feedback Status Date': this.getLastFeedbackStatusDate(c) || '',
            'Last Feedback': this.getFormattedComments(c) || '',
            'Last Feedback Score': this.getFormattedCSATscore(c) || '',
          },
        );
      }
      downloadAsFile({
        dataType: 'table',
        data: data_points,
        filename: this.returnReportFileName('Feedback'),
      });
    },

    handleDatePickerChange(newDateRange) {
      this.dateRange = setToEndOfDay(getNonReactiveDateRange(newDateRange));
    },
    async loadList(ManagementParams) {
      const params = {
        limit: this.searchPageSize,
        offset: get(ManagementParams, 'searchOffset', 0),
        query: this.searchTerm,
      };

      this.extendStateData = false;
      if (this.dateRange && this.dateRange.length === 2) { // eslint-disable-line no-magic-numbers
        params.period_start = dayjs(this.dateRange[0]).unix() || null;
        params.period_end = dayjs(this.dateRange[1]).unix() || null;
      }

      if (!isEmpty(this.filterScores)) {
        params.feedback_scores = this.filterScores.join(',');
      }

      const segmentNames = get(this.selectedFilters, '0.customer_segment_names', []);
      const agentIds = get(this.selectedFilters, '0.agents', []);

      if (!isEmpty(segmentNames)) {
        params.customer_segment_names = segmentNames;
      }

      if (!isEmpty(agentIds)) {
        params.agent_ids = agentIds;
      }

      if (params.offset !== 0) {
        this.extendStateData = true;
      }

      const extend_state = this.extendStateData;
      const response = await this.getFeedbackList({ params, extend_state });
      this.pagination = get(response, 'pagination', PAGINATION_DEFAULT);
      this.loading = false;
    },
    pullFeedback(ManagementParams) {
      debounce(async() => {
        await this.loadList(ManagementParams);
      }, DEBOUNCE_DELAY_MS)();
    },
    applyScoreFilter(scoreObjects) {
      this.filterScores = scoreObjects.map(scoreObject => scoreObject.value);
    },
    onSegmentHover(segment) {
      this.segmentAlias = get(segment, 'alias', '');
    },
    returnReportFileName(chartName = 'data') {
      const [startTimestamp, endTimestamp] = this.dateRange;
      const startDate = dayjs.isDayjs(startTimestamp)
        ? startTimestamp.format('YYYY-MM-DD')
        : dayjs(startTimestamp).format('YYYY-MM-DD');
      const endDate = dayjs.isDayjs(endTimestamp)
        ? endTimestamp.format('YYYY-MM-DD')
        : dayjs(endTimestamp).format('YYYY-MM-DD');
      return `${chartName}_${startDate}_${endDate}`;
    },
    onChartDataChange(data) {
      if (data?.dataset) {
        data.dataset = data.dataset.map(item => {
          if (item.metric === 'csat_score') {
            item.data_points = item.data_points.map(dp => {
              const hasNoPercent = !_.find(dp.ys, { metric_category: 'percent' });
              if (hasNoPercent) {
                dp.ys.push({
                  metric_category: 'percent',
                  value: _.get(dp.ys.find(y => y.metric_category === 'feedback'), 'value', 0),
                });
              }
              return dp;
            });
          }
          return item;
        });
      }
      const dataPoints = data?.dataset?.[0]?.data_points || [];
      this.surveyChartData = dataPoints;
      this.originalSurveyChartData = cloneDeep(data);
    },
    isDataPartial(date) {
      const timeStamp = new Date(date).getTime();
      const isPartial = this.surveyChartData.find(item => item.x === timeStamp)?.isPartial;
      return isPartial;
    },
    xAxisFormatForSurveyCharts(date) {
      // eslint-disable-next-line
      return this.xLabelsSurveyChart[dayjs(date).valueOf()] + `${this.isDataPartial(date) ? ' *' : ''}` ;
    },
    async loadTzAbbr(tz) {
      this.tzAbbr = getMetricsTimeZoneAbbr(tz);
    },
  },
  async mounted() {
    this.timezone = await useTimeZone(
      Intl.DateTimeFormat().resolvedOptions().timeZone,
      this.$store.dispatch,
      this.$store._state.data.configs,
    );
    await this.loadTzAbbr(this.timezone);
    await this.getFeedbackType();
    this.initialLoaded = true;
    this.$store.dispatch('configs/getCustomerSegments');
    await this.loadList();
    await loadFilterOptions(this, this.agentsEndpoint);
  },
};
</script>

<style lang="scss" scoped>
  .chart-configuration {
      display: flex;
      margin-bottom: 24px;
      .time-range-filter {
        position: relative;
        justify-content: flex-end;
        margin-left: auto;
      }
      .breakdown {
        display: flex;
        align-items: center;
        flex-grow: 1;
      }
      .members-filter {
        display: flex;
        align-items: center;
      }
      .chart-toolbar {
       display: flex;
       margin-bottom: 20px;
       .dropdown-filters {
          display: flex;
          align-items: flex-start;
          width: 60%;
          .dropdown-filter {
            margin-right: 12px;
            width: 40em;
            height: 30px;
            :deep(.el-select) {
                width:  75%;
            }
          }
       }
       .flex-spacer {
         flex-grow: 1;
      }
      }
  }
  .status-indicator {
    &::before {
      margin-top: 1px;
    }
  }
  .right-aligned {
    float: right;
  }

  .chart-grid {
    margin: 24px 0;
  }

  .feedback {
    width: 100%;
    height: 100%;
  }

  .feedback-table{
    margin: 10px 0px 10px 0px;
  }

  .feedback-table-toolbar {
    display: flex;
    align-items: center;

    .flex-spacer {
      flex-grow: 1;
    }

    .search {
      max-width: 350px;
    }

    .el-select {
      width: 150px;
      margin-left: 16px;
    }

    .pagination-info {
      margin-left: 16px;
      font-size: 13px;
      color: #606266;
      white-space: nowrap;
    }
  }
</style>

<style lang="scss" scoped>
@import "../../../../styles/aiq-mixins.scss";

.normal-word-break{
  .cell{
    word-break: normal !important;
  }
}
.feedback-table {
  .feedback-table-toolbar {
    .el-button.export {
      height: 30px;
      width: 40px;
      padding: 0;
      margin-left: 16px;

      &:after {
        clear: both;
      }
    }
  }
}


:deep(.el-table__body-wrapper) {
    @include scrollable(calc(100vh - 247px));
    .el-scrollbar {
        height: calc(100vh - 247px);
    }
}




</style>
